<template>
  <div class="ren-decoration-field-group">
    <label>富文本</label>
    <textarea
      class="ren-control ren-decoration-textarea"
      :disabled="readonly"
      :value="html"
      placeholder="请输入内容"
      @input="onInput"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mergeWidgetProps, type WidgetSettingsProps } from '../../types'

const props = withDefaults(defineProps<WidgetSettingsProps>(), {
  readonly: false
})

const emit = defineEmits<{
  'update:props': [props: Record<string, unknown>]
}>()

const html = computed(() => String(props.component.props?.html ?? ''))

function onInput(event: Event) {
  const value = (event.target as HTMLTextAreaElement).value
  emit('update:props', mergeWidgetProps(props.component, { html: value }))
}
</script>
